import { createFinalFormValidation } from "@lemoncode/fonk-final-form";
import { Validators } from '@lemoncode/fonk';
import { isNumber } from '@lemoncode/fonk-is-number-validator';
import { isTrue } from '@lemoncode/fonk-is-true-validator';
import {isBadgeAward, isCustomAward} from "@/shared/helpers";

isTrue.setErrorMessage("This field is required");

Validators.required.setErrorMessage("This field is required");

export const maxAwardableAmountRequiredValidator = args => {
  const { values } = args;

  if (isBadgeAward(values.event_type_id) || isCustomAward(values.event_type_id)) {
    return {
      succeeded: true,
      type: 'max_awardable_amount_required',
      message: ''
    };
  }

  return Validators.required.validator(args);
};

export const maxAwardableAmountNumberValidator = args => {
  const { values } = args;

  if (isBadgeAward(values.event_type_id) || isCustomAward(values.event_type_id)) {
    return {
      succeeded: true,
      type: 'max_awardable_amount_number',
      message: ''
    };
  }

  return isNumber.validator(args);
};

const validationSchema = {
    field: {
        name: [Validators.required.validator],
        // icon: [Validators.required.validator],
        event_type_id: [Validators.required.validator],
        max_awardable_amount: [maxAwardableAmountRequiredValidator, maxAwardableAmountNumberValidator],
        event_icon_id: [Validators.required.validator, isNumber.validator],
        awarding_points: [isNumber.validator],
        message: [Validators.required.validator],
    }
}
const formValidation = createFinalFormValidation(validationSchema);
export default formValidation;
